export enum MenuEnum {
    ControlPanel = 19,
    CyberRisk = 10,
    Risk = 2,
    Crew=8,
    Audit=41
}
